import React from 'react';

import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import NoDairyIcon from 'src/components/GetStarted/Icons/AllergenFooter/NoDairyIcon';
import NoGlutenIcon from 'src/components/GetStarted/Icons/AllergenFooter/NoGlutenIcon';
import NoRefinedSugarsIcon from 'src/components/GetStarted/Icons/AllergenFooter/NoRefinedSugarsIcon';

const allergenConfig = [
  {
    icon: <NoGlutenIcon />,
    header: 'No gluten',
    description: `We don’t use any ingredients with gluten in our meals because 
      they can contribute to inflammation for many people.`,
  },
  {
    icon: <NoDairyIcon />,
    header: 'No dairy',
    description: `Dairy is another ingredient we avoid, to reduce inflammation 
      and ensure efficiency of the digestive tract.`,
  },
  {
    icon: <NoRefinedSugarsIcon />,
    header: 'No refined sugars',
    description: `We steer clear of all refined sugars, like cane sugar and 
      corn syrup, due to links to adverse health issues.`,
  },
];

/**
 * Bottom banner to display allergen info.
 */
const AllergenFooter: React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        maxWidth: '100vw',
        overflowX: 'hidden',
        margin: 'auto',
        padding: '2rem 0',
        backgroundColor: theme.palette.grey[200],
      }}
    >
      <Typography variant="h3" sx={{ textAlign: 'center' }}>
        Clean Ingredients
      </Typography>
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          maxWidth: theme.breakpoints.values.contentMaxWidth,
          margin: '0 auto',
        }}
      >
        {allergenConfig.map(({ icon, header, description }) => (
          <Grid
            key={`alg-${header}`}
            sx={{ padding: '1.5rem 0 0 0' }}
            size={{
              xs: 12,
              md: 3,
            }}
          >
            <Card elevation={0} sx={{ background: 'none' }}>
              <CardContent>
                <Stack sx={{ textAlign: 'center' }}>
                  <Box sx={{ marginBottom: '1.5rem' }}>{icon}</Box>
                  <Typography sx={{ marginBottom: '0.5rem' }} variant="body1">
                    {header}
                  </Typography>
                  <Typography variant="body2">{description}</Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AllergenFooter;
